import React, { useEffect, useState } from 'react';

import ToastPopup from 'Components/organisms/ToastPopup';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);
function ToastPopupComponent() {
  const [title, setTitle] = useState('타이틀입니다.');
  const [description, setDescription] = useState('설명입니다.');
  const [sec, setSec] = useState(2);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    document.documentElement.children[1].style.overflow = 'hidden';
  }, []);
  return (
    <div className={cx('toast-popup')}>
      타이틀:{' '}
      <input
        placeholder="타이틀"
        value={title}
        onChange={(e) => {
          setTitle(e.target.value);
        }}
      />
      <br />
      설명:{' '}
      <input
        placeholder="타이틀"
        value={description}
        onChange={(e) => {
          setDescription(e.target.value);
        }}
      />
      <br />
      띄울 초:{' '}
      <input
        type="number"
        placeholder="초"
        value={sec}
        onChange={(e) => {
          setSec(e.target.value);
        }}
      />
      <br />
      <button onClick={() => setOpen(true)}>팝업 띄우기</button>
      <ToastPopup
        showSecond={sec}
        close={() => setOpen(false)}
        open={open}
        title={title}
        description={description}
      />
    </div>
  );
}

export default ToastPopupComponent;

export const path = '/toast_popup';
